const messages = {
  title: 'Greška isteka vremena pristupa',
  description: 'Jako nam je žao zbog neugodnosti. Izgleda da naš server nekako nije primio pravovremeni odgovor.',
  backHomeButton: 'Nazad na kontrolnu tablu'
}

export default {
  messages
}
